import { useContext } from "react"
import { RevisionEditingContext } from "./RevisionEditingContext"

export const useRevisionEditing = () => {
  return useContext(RevisionEditingContext)
}
